import createHistory from 'history/createBrowserHistory';

/**
 * This exports a singleton so that it can be imported in store.ts and passed
 * as an argument to routerMiddleware(). This allows us to import elsewhere
 * and call history.push(path, state) to let Gamma handle a route with state.
 **/
export default createHistory();



// WEBPACK FOOTER //
// ./app/common/history/index.ts